import axios from 'axios'
import API from '../../../api'
import keycloak from '../../../keycloak'

// DTmood ya acepta el token de Keycloak directamente (confirmado por su
// equipo) -- no hace falta el login propio de DTmood ni su ciclo de
// refresh (`refreshAccessToken`/`dtmood_session`, ver login.service.js,
// que queda sin usar acá). El refresco del token lo maneja Keycloak de
// forma global (`keycloak.onTokenExpired`, ver src/index.js); si de
// cualquier forma DTmood devuelve un 401, dejamos que el interceptor
// global de axios (src/authInterceptor.js) lo maneje redirigiendo a login,
// en vez de duplicar esa lógica acá.
const apiDtMood = axios.create({
  baseURL: API.urlDtMood
})

apiDtMood.interceptors.request.use(
  function (config) {
    config.headers = {
      'Content-Type': 'application/json',
      accept: 'application/json'
    }

    if (keycloak.token) {
      config.headers.Authorization = `Bearer ${keycloak.token}`
    }

    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default apiDtMood
